import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class EvidenceBundleService {
    constructor(api) {
        this.api = api;
    }

    async list(entityType, entityId) {
        return this._read(() => this.api.list(entityType, entityId), 'Failed to list evidence bundles');
    }

    async getById(id) {
        return this._read(() => this.api.getById(id), 'Failed to load evidence bundle');
    }

    async create(input) {
        return this._write(() => this.api.create(input), 'Failed to create evidence bundle');
    }

    async seal(id) {
        return this._write(() => this.api.seal(id), 'Failed to seal evidence bundle');
    }

    async export(id, format = 'json') {
        try {
            const response = await this.api.export(id, format);
            return { success: true, data: response.data, metadata: response.metadata };
        } catch (error) {
            throw this._handleError(error, 'Failed to export evidence bundle');
        }
    }

    async _read(operation, message) {
        try {
            const response = await withRetry(operation, { maxRetries: 2 });
            return { success: true, data: response.data };
        } catch (error) {
            throw this._handleError(error, message);
        }
    }

    async _write(operation, message) {
        try {
            const response = await operation();
            return { success: true, data: response.data };
        } catch (error) {
            throw this._handleError(error, message);
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
